/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
import router from '../router';
import baseUrl from '../../static/config.json';
import cookie from "../service/cookie";
import {message} from "../commonJs/ResetMessage";

/**
 * 提示函数
 * 显示2秒后关闭
 */
function tip(msg, type = 'error') {
  message({
    message: msg,
    type: type,
    duration: 2000,
    showClose: true
  });
}

let api_version = 'v2.4.1';

axios.create();

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout') !== -1){
      tip('请求超时，请重新刷新页面');
      return;
    }
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: '/login',
            query: {redirect: router.currentRoute.fullPath}
          });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          tip('登录过期，请重新登录');
          // 清除token
          cookie.setCookie('access_token_ul_wf', '');
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
          tip('网络请求不存在');
          break;
        // 其他错误，直接抛出错误提示
        case 500:
          tip(error.response.data.message);
          break;
        default:
          tip(error.response.data.message);
      }
      return Promise.reject(error.response);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} Req [请求时携带的参数]
 */
function fetchGet(url, Req,isSpecial = false) {
  let params = {
    ver: api_version, // v1
    agent: 'pc', // mobile | pc | wx
    req: Req
  };
  let base_url = baseUrl.API_ROOT;
  if(isSpecial){
    params = Req;
  }
  return new Promise((resolve, reject) => {
    axios.get(base_url + url + '?Authorization=' + cookie.getCookie('access_token_ul_wf'), {
      headers: {
        'Content-Type': "application/json"
      },
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function fetchPost(url, Req,api,isSpecial = false) {
  let params = {
    ver: api_version,
    // agent: navigator.userAgent,
    agent: 'pc',
    req: Req
  };
  let api_url = api ? api :baseUrl.API_ROOT;
  if(isSpecial){
    params = Req;
  }


  if(url.indexOf('Export') == -1 || url.indexOf('Edit') == -1){
    axios.defaults.timeout = 10000;
  }else{
    axios.defaults.timeout = 0;
  }

  return new Promise((resolve, reject) => {
    axios.post(api_url + url + '?Authorization=' + cookie.getCookie('access_token_ul_wf'), QS.parse(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      })
  });
}

export default {
  fetchGet: fetchGet,
  fetchPost: fetchPost,
}



// WEBPACK FOOTER //
// ./src/request/request.js